import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { LinkExternal, VerificationService } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const FaqLinkComponent = ({ verificationService }: Props) => {
    const { segment } = verificationService.verificationResponse;
    const { programId } = verificationService;

    if (segment) {
        const faqHref = `https://verify.sheerid.com/professions-faq/?pid=${programId}`;

        return (
            <LinkExternal className="sid-faq sid-link" href={faqHref}>
                <FormattedHTMLMessage id="getHelp" defaultMessage="Get Help" />
            </LinkExternal>
        );
    }
    return null;
};

export { FaqLinkComponent };
